/**
 * Created by charnjeetelectrovese@gmail.com on 5/1/2020.
 */

import {postRequest, getRequest} from "../libs/AxiosService.util";

import axios from "axios";
import Constants from "../config/constants";

export async function serviceGetThemeByDomain() {
    try {
        const baseUrl = Constants.DEFAULT_APP_URL.replace('dietitian/', '');
        const tempRequest = await axios.post(`${baseUrl}admin/clients/theme-by-domain`, {});
        if (tempRequest.status === 200 && tempRequest.data.response_code === 1) {
            return { error: false, data: tempRequest.data.response_obj };
        }
        return { error: true, message: tempRequest?.data?.response_message };
    } catch (err) {
        return { error: true, message: "Something went wrong" };
    }
}

export async function serviceGetAppSettings(params) {
    return await postRequest('app/setting', params);
}

export async function serviceUpdateGeoFence(params) {
    return await postRequest('app/settings/geofence/update', params);
}

export async function serviceUpdatePolicies(params) {
    return await postRequest('app/setting/update/policies', params);
}
export async function serviceLoginUsingGoogleAuth (params) {
    return await postRequest('/auth/social/login', params);
}


